import scrollTo from '../util/scroll-to';

const selectors = {
  headerSticky: '[data-header-sticky]',
  headerHeight: '[data-header-height]',
  scrollToElement: '[data-scroll-to]',
  scrollToElementValue: 'data-scroll-to',
  scrollToLinks: '[data-scroll-to-links]',
  scrollSpy: '[data-scroll-spy]',
  accordionHolder: '[data-accordion-holder]',
  accordionToggle: '[data-accordion-toggle]',
  tooltip: '[data-tooltip]',
  tooltipStopMousenterValue: 'data-tooltip-stop-mouseenter',
};

const classes = {
  open: 'is-open',
  selected: 'is-selected',
};

const sections = {};

class ScrollToElement {
  constructor(section) {
    this.section = section;
    this.container = section.container;
    this.scrollToButtons = this.container.querySelectorAll(selectors.scrollToElement);
    this.scrollSpyElement = this.container.querySelector(selectors.scrollSpy);

    if (this.scrollToButtons.length) {
      this.init();
    }

    if (this.scrollSpyElement) {
      this.scrollSpy();
    }
  }

  init() {
    this.scrollToButtons.forEach((element) => {
      element.addEventListener('click', (e) => {
        e.preventDefault();
        const target = document.querySelector(element.getAttribute(selectors.scrollToElementValue));

        if (!target) return;
        const accordionToggle = target.querySelector(selectors.accordionToggle);
        let timeoutFlag = false;
        const scrollToLinks = element.closest(selectors.scrollToLinks);

        if (scrollToLinks && !element.closest(selectors.scrollSpy)) {
          const selectedItems = scrollToLinks.querySelectorAll(`.${classes.selected}`);
          if (selectedItems.length) {
            selectedItems.forEach((selectedItem) => {
              selectedItem.classList.remove(classes.selected);
            });
          }
          element.classList.add(classes.selected);
        }

        // Open target accordion if they are inside it
        if (accordionToggle) {
          const accordionHolder = accordionToggle.closest(selectors.accordionHolder);

          if (!accordionToggle.classList.contains(classes.open) && accordionHolder && accordionHolder.querySelector(`${selectors.accordionToggle}.${classes.open}`)) {
            timeoutFlag = true;
          }

          if (!accordionToggle.classList.contains(classes.open)) {
            accordionToggle.dispatchEvent(new Event('click'));
          }
        }

        if (timeoutFlag) {
          setTimeout(() => this.scrollToElement(target), 500);
        } else {
          this.scrollToElement(target);
        }
      });
    });
  }

  scrollToElement(element) {
    scrollTo(element.getBoundingClientRect().top);

    const tooltips = document.querySelectorAll(`${selectors.tooltip}:not([${selectors.tooltipStopMousenterValue}])`);
    if (tooltips.length) {
      tooltips.forEach((tooltip) => {
        tooltip.setAttribute(selectors.tooltipStopMousenterValue, '');

        setTimeout(() => {
          tooltip.removeAttribute(selectors.tooltipStopMousenterValue);
        }, 1000);
      });
    }
  }

  scrollSpy() {
    const buttons = this.scrollSpyElement.querySelectorAll(selectors.scrollToElement);
    if (!buttons) return;
    const headerHeight =
      document.querySelector(selectors.headerSticky) && document.querySelector(selectors.headerHeight) ? document.querySelector(selectors.headerHeight).getBoundingClientRect().height : 0;

    window.addEventListener('scroll', () => {
      const scrollPos = Math.ceil(document.documentElement.scrollTop || document.body.scrollTop);
      buttons.forEach((element) => {
        const target = document.querySelector(element.getAttribute(selectors.scrollToElementValue));
        if (target.offsetTop - headerHeight <= scrollPos) {
          this.scrollSpyElement.querySelector(`.${classes.selected}`).classList.remove(classes.selected);
          this.scrollSpyElement.querySelector(`[${selectors.scrollToElementValue}="#${target.id}"]`).classList.add(classes.selected);
        }
      });
    });
  }
}

const scrollToElement = {
  onLoad() {
    sections[this.id] = new ScrollToElement(this);
  },
};

export default scrollToElement;
